



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import "swiper/css";
// import { FaStar } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const VerifiedSuppliersCarousel = () => {
//   const [suppliers, setSuppliers] = useState([]);
//  const [supplierRatings, setSupplierRatings] = useState({});// ✅ NEW
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchSuppliers = async () => {
//       try {
//         const res = await axios.get(
//           "https://api.mahal.qa/api/suppliers"
//         );

//         console.log("🔥 SUPPLIERS:", res.data);

//         const supplierList = res.data.suppliers || [];
//         setSuppliers(supplierList);

//         fetchSupplierRatings(supplierList); // ✅ NEW
//       } catch (err) {
//         console.error("❌ Supplier fetch error:", err);
//       }
//     };

//     fetchSuppliers();
//   }, []);

//   /* ================= FETCH SUPPLIER RATINGS ================= */
//   const fetchSupplierRatings = async (suppliers) => {
//     try {
//       const ratingMap = {};

//       await Promise.all(
//         suppliers.map(async (supplier) => {
//           try {
//             // 1️⃣ Get supplier products
//             const productRes = await axios.get(
//               `https://api.mahal.qa/api/products?supplier_id=${supplier.id}`
//             );

//             const products = productRes.data.products || [];

//             let totalRating = 0;
//             let totalReviews = 0;

//             // 2️⃣ Get reviews for each product
//             await Promise.all(
//               products.map(async (p) => {
//                 try {
//                     const productId =
//                       p.product_id ??
//                       p.id ??
//                       p.productId;

//                           // ✅ ADD LOGS HERE
//                     console.log("PRODUCT:", p);
//                     console.log("USING ID:", productId);

//                     if (!productId) return;

//                     const reviewRes = await axios.get(
//                       `https://api.mahal.qa/api/reviews/product/${productId}`
//                     );

//                   const reviews = reviewRes.data || [];

//                   reviews.forEach((r) => {
//                     totalRating += r.rating;
//                     totalReviews += 1;
//                   });
//                 } catch {}
//               })
//             );

//             // 3️⃣ Calculate average
//             ratingMap[supplier.id] =
//               totalReviews > 0 ? totalRating / totalReviews : 0;

//           } catch {
//             ratingMap[supplier.id] = 0;
//           }
//         })
//       );

//       setSupplierRatings(ratingMap);
//     } catch (err) {
//       console.error("Supplier rating error:", err);
//     }
//   };

//   return (
//     <section className="supplier-section">
//       <div className="container">

//         {/* HEADER */}
//         <div className="supplier-header">
//           <h2>Verified Suppliers</h2>
//           <p>Trusted partners powering restaurant procurement</p>
//         </div>

//         <Swiper
//           spaceBetween={25}
//           autoplay={{ delay: 2500 }}
//           loop={suppliers.length > 5}
//           modules={[Autoplay]}
//           breakpoints={{
//             320: { slidesPerView: 1.2 },
//             480: { slidesPerView: 2 },
//             576: { slidesPerView: 3 },
//             768: { slidesPerView: 4 },
//             992: { slidesPerView: 5 },
//             1400: { slidesPerView: 6 },
//           }}
//         >
//           {suppliers.map((supplier, index) => {
//             const ratingValue = supplierRatings[supplier.id] || 0; // ✅ FIXED

//             return (
//               <SwiperSlide key={supplier.id || index}>
//                 <div className="supplier-card">

//                   {/* VERIFIED */}
//                   <div className="verified-ribbon">
//                     ✔ Verified
//                   </div>

//                   {/* IMAGE */}
//                   <div className="supplier-logo">
//                     <img
//                   src={
//                     supplier.image && supplier.image.trim() !== ""
//                       ? supplier.image.startsWith("http")
//                         ? supplier.image
//                         : `https://api.mahal.qa/${supplier.image}`
//                       : null
//                   }
//                   alt={supplier.name}
//                   onError={(e) => {
//                     console.log("Image failed:", supplier.image);
//                     e.target.style.display = "none";
//                   }}
//                 />
//                   </div>

//                   {/* NAME */}
//                   <h6 className="supplier-name">
//                     {supplier.name}
//                   </h6>

//                   {/* ✅ UPDATED RATING */}
//                   <div className="supplier-rating">
//                     <FaStar className="star-icon" />
//                     {ratingValue.toFixed(1)}
//                   </div>

//                   {/* META */}
//                   <div className="supplier-meta">
//                     <p>{supplier.delivery || "Fast Delivery"}</p>
//                     <p>{supplier.minOrder || "Min Order ₹5000"}</p>
//                   </div>

//                   {/* BUTTON */}
//                   <button
//                     className="view-btn"
//                     onClick={() =>
//                       navigate(
//                         `/categorieList?supplier=${supplier.id}&name=${encodeURIComponent(
//                           supplier.name
//                         )}`
//                       )
//                     }
//                   >
//                     View Supplier
//                   </button>

//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>

//       </div>
//     </section>
//   );
// };

// export default VerifiedSuppliersCarousel;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FaStar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const API_BASE = "https://api.mahal.qa/api";

const VerifiedSuppliersCarousel = () => {
  const [suppliers, setSuppliers] = useState([]);
  const navigate = useNavigate();
const { t, i18n } = useTranslation();
const isArabic = i18n.language === "ar";

const getSupplierName = (supplier) => {
  return isArabic
    ? supplier.name_ar || supplier.name
    : supplier.name;
};

const localizePercent = (value) => {
  return isArabic
    ? `٪${new Intl.NumberFormat("ar-QA").format(value)}`
    : `${value}%`;
};

const localizeNumber = (value) => {
  return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(Number(value || 0));
};

const localizeMinOrder = (value) => {
  if (!value) return t("min_order_5000");

  return value
    .replace("Min Order", t("min_order"))
    .replace("QAR", t("qar"))
    .replace(/\d+/g, (num) =>
      new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(Number(num))
    );
};

const localizeDelivery = (value) => {
  if (!value) return t("fast_delivery");

  return value === "Fast Delivery" ? t("fast_delivery") : value;
};
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const res = await axios.get(`${API_BASE}/suppliers`);

        console.log("🔥 SUPPLIERS FROM API:", res.data);

        const supplierList = res.data.suppliers || [];
        setSuppliers(supplierList);

      } catch (err) {
        console.error("❌ Supplier fetch error:", err);
      }
    };

    fetchSuppliers();
  }, []);

  return (
    <section className="supplier-section">
      <div className="container">

        {/* HEADER */}
        <div className="supplier-header">
          <h2>{t("verified_suppliers")}</h2>
          <p>{t("trusted_partners_procurement")}</p>
        </div>

        <Swiper
          key={isArabic ? "ar" : "en"}
          dir={isArabic ? "rtl" : "ltr"}
          spaceBetween={25}
          autoplay={{ delay: 2500 }}
          loop={suppliers.length > 5}
          modules={[Autoplay]}
          breakpoints={{
            320: { slidesPerView: 1.2 },
            480: { slidesPerView: 2 },
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
            1400: { slidesPerView: 6 },
          }}
        >
          {suppliers.map((supplier, index) => {
            // ✅ USE RATING DIRECTLY FROM /api/suppliers
            const ratingValue = Number(supplier.rating || 0);

            return (
              <SwiperSlide key={supplier.id || index}>
                <div className="supplier-card">

                  {/* VERIFIED */}
                  <div className="verified-ribbon">
                    ✔ {t("verified")}
                  </div>

                  {/* IMAGE */}
                  <div className="supplier-logo">
                    <img
                      src={
                        supplier.image && supplier.image.trim() !== ""
                          ? supplier.image.startsWith("http")
                            ? supplier.image
                            : `https://api.mahal.qa/${supplier.image}`
                          : null
                      }
                      alt={getSupplierName(supplier)}
                      onError={(e) => {
                        console.log("Image failed:", supplier.image);
                        e.target.style.display = "none";
                      }}
                    />
                  </div>

                  {/* NAME */}
                  <h6 className="supplier-name">
                    {getSupplierName(supplier)}
                  </h6>

                  {/* ✅ REAL SUPPLIER RATING */}
                  <div className="supplier-rating">
                    <FaStar className="star-icon" />
                    {localizeNumber(ratingValue)}
                  </div>

                  {/* META */}
                  <div className="supplier-meta">
                    <p>{localizeDelivery(supplier.delivery)}</p>
                    <p>{localizeMinOrder(supplier.minOrder)}</p>
                  </div>

                  {/* BUTTON */}
                  <button
                    className="view-btn"
                    onClick={() =>
                      navigate(
                        `/categorieList?supplier=${supplier.id}&name=${encodeURIComponent(
                          supplier.name
                        )}`
                      )
                    }
                  >
                   {t("view_supplier")}
                  </button>

                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

      </div>
    </section>
  );
};

export default VerifiedSuppliersCarousel;